import { extendObservable, runInAction } from 'mobx';

import { ERROR_STATUSES } from '../models/ApiError';
import { PasswordConfirmationStore } from '../stores/PasswordConfirmationStore';
import { PhoneController } from '../networking/controllers/PhoneController';
import { Logger } from '../helpers/Logger';

class PhoneStoreClass {
  constructor() {
    extendObservable(this, {
      createError: false,
      loadingPhones: false,
      phones: [],
      message: '',
    });

    this.getPhones = this.getPhones.bind(this);
  }

  async addPhone(number) {
    runInAction(() => {
      this.createError = false;
    });
    try {
      const phone = await PhoneController.addPhone(number);
      runInAction(() => {
        this.phones.push(phone);
      });
    } catch (error) {
      Logger.warn(error);
      if (error.response && error.response.status === ERROR_STATUSES.PRECONDITION_FAILED) {
        // Wait for confirmation and try to submit again when done
        try {
          await PasswordConfirmationStore.showConfirmationModal(() => this.addPhone(number));
          return;
        } catch (_) {
          runInAction(() => {
            this.createError = true;
          });
        }
      }
      runInAction(() => {
        this.errorMessage = error.message;
        this.createError = true;
      });
    }
  }

  async getPhones() {
    runInAction(() => {
      this.loadingPhones = true;
    });
    try {
      const phones = await PhoneController.getPhones();
      runInAction(() => {
        this.phones = phones;
      });
    } catch (error) {
      Logger.warn(error);
    } finally {
      runInAction(() => {
        this.loadingPhones = false;
      });
    }
  }

  async deletePhone(phone) {
    try {
      await PhoneController.deletePhone(phone.number);
      const phones = this.phones.filter(ph => ph.id !== phone.id);
      runInAction(() => {
        this.phones = phones;
      });
    } catch (error) {
      Logger.warn(error);
      if (error.response && error.response.status === ERROR_STATUSES.PRECONDITION_FAILED) {
        // Wait for confirmation and try to submit again when done
        try {
          await PasswordConfirmationStore.showConfirmationModal(() => this.deletePhone(phone));
        } catch (confirmationError) {
          Logger.warn(confirmationError);
        }
      }
    }
  }
}

const PhoneStore = new PhoneStoreClass();

export { PhoneStore };



// WEBPACK FOOTER //
// ./src/stores/PhoneStore.js